import React from "react";
import PropTypes from 'prop-types';
import { resolvePath } from '@webapps/utils';
import { TextField } from "@material-ui/core";
import { css } from "@emotion/css";


const FormikHourPicker = ({
  defaultValue = null,
  formik: { errors, setFieldValue, touched, values },
  fullWidth,
  label,
  name,
  pathValue,
  inputProps,
  InputProps,
  disabled,
  onDisabledClick,
  variant = "outlined",
  borderRadius,
  ...props
}) => {
  const value = pathValue ? resolvePath(values, name, '') : values[name];

  const handleTimeChange = (event) => {
    const timeValue = event.target.value;
    const [hours, minutes] = timeValue.split(":").map(Number);
    
    if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
      setFieldValue(
        name,
        pathValue ? resolvePath(timeValue, pathValue, false) : timeValue,
        true
      );
    }
  };

  return (
      <TextField
        label={label}
        type="time"
        value={value || ""}
        onChange={handleTimeChange}
        disabled={disabled}
        onClick={(e) => !disabled && handleTimeChange(e)}
        variant={variant}
        fullWidth={fullWidth}
        error={!!resolvePath(touched, name, '') && !!resolvePath(errors, name, '')}
        helperText={resolvePath(touched, name, '') && resolvePath(errors, name, '')}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 300,
          pattern: "([01]?[0-9]|2[0-3]):[0-5][0-9]",
          ...inputProps,
        }}
        className={
            css({
                ".MuiOutlinedInput-root": {
                    borderRadius: `${borderRadius}px !important`,
                },
                ".MuiOutlinedInput-input": {
                    paddingTop: "10.5px",
                    paddingBottom: "10.5px",
                    color: "#152652",
                    fontSize: "13.5px",
                },
                ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C0D9FF !important"
                },
                ".MuiFormLabel-root": {
                    color: "#5D75A8",
                    top: "1px",
                    fontSize: "13.5px"
                },
            })
        }
        InputProps={InputProps}
        sx={{
          width: fullWidth ? "100%" : "auto",
          cursor: disabled ? "not-allowed" : "pointer",
          "& .MuiInputBase-root": {
            cursor: disabled ? "not-allowed" : "pointer",
            borderRadius: borderRadius,
       
          },
          ...props.sx
        }}
        {...props}
      />
  );
};

FormikHourPicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  formik: PropTypes.object,
  fullWidth: PropTypes.bool,
  pathValue: PropTypes.string,
  disabled: PropTypes.bool,
  onDisabledClick: PropTypes.func,
  variant: PropTypes.string,
  borderRadius: PropTypes.number,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
};

export default FormikHourPicker;